export enum USER_TYPE {
  client = 'Client',
  prospect = 'Prospect',
  subscriber = 'Abonné',
  formerClient = 'AncienClient',
}
